import ErrorCatcher from './ErrorCatcher';
export default ErrorCatcher;